module.exports = __webpack_public_path__ + "img/3rd.cd3a53e.png";